import React, { Component, useEffect, useState } from 'react';
import './InvalidCombo.scss';
import { CloseXIcon } from '../../../../../UI/Icons/Icons';

export default function InvalidCombo(props) {
  const closeTip = () => {
    props.passedFunctions.hideCheckForErrors();
    if ($('.invalidComboContainer').css('display') == 'block') $('.invalidComboContainer').css('display', 'none');
  };

  useEffect(() => {
    if (props.passedFunctions.parentState.checkForErrors == true) {
      if ($('.invalidComboContainer').css('display') == 'none') $('.invalidComboContainer').css('display', 'block');
      if ($('.invalidComboContainer').css('display') == 'block') {
        $(document).on('mouseup click', '.swiper-container', function () {
          $('.invalidComboContainer').css('display', 'none');
          closeTip();
        });

        $(document).on('mouseup', 'html', function () {
          $('.invalidComboContainer').css('display', 'none');
          closeTip();
        });
      }
    }
  });

  var parentState = props.passedFunctions.parentState;
  var isItemAttrPage = props.itemKey !== undefined;
  var verbiageToShow = '';

  function isVowel(x) {
    return 'aeiouAEIOU'.indexOf(x) != -1;
  }

  function buildErrorStr(isItemAttr) {
    let returnStr = '';
    let invalidFields = [];
    if (isItemAttr) {
      Object.values(parentState.currentAttributeState).map((val) => {
        if (!val.selectedValue && val.attrName !== 'Item') {
          if (!val.selectedValue) {
            invalidFields.push(val.attrName.toLowerCase());
          }
        }
      });
    } else {
      Object.values(parentState.currentAttributeState).map((val) => {
        if (!val.selectedValue) {
          if (!val.selectedValue) {
            invalidFields.push(val.attrName.toLowerCase());
          }
        }
      });
    }

    if (
      invalidFields.length === 0 &&
      props.passedFunctions.parentState.checkForErrors &&
      props.passedFunctions.parentState.formValid === false
    ) {
      returnStr = "Your combination isn't available at this time. Choose from the available options to continue.";
    } else {
      if (invalidFields.length > 0) {
        returnStr = 'Select a';
        if (invalidFields.length > 0) {
          invalidFields.map((val, i) => {
            if (isVowel(val.substr(0, 1))) {
              returnStr += 'n';
            }
            returnStr += ' ' + val + ' ';
            if (i + 1 != invalidFields.length) returnStr += 'and ';
          });
        }
        returnStr += 'to continue';
      }
    }
    return returnStr;
  }

  if (props.passedFunctions.parentState.checkForErrors && !props.passedFunctions.parentState.formValid) {
    let isItemAttr = false;
    if (isItemAttrPage) {
      isItemAttr = true;
      verbiageToShow = buildErrorStr(isItemAttr);
    } else {
      verbiageToShow = buildErrorStr(isItemAttr);
    }
  }

  return (
    <>
      {props.passedFunctions.parentState.checkForErrors &&
        props.itemKey == undefined &&
        !props.passedFunctions.parentState.formValid &&
        verbiageToShow.length > 0 && (
          <div id='invalidComboContainer' className='invalidComboContainer' tabIndex='0'>
            <button className='closeTip btn-tertiary' type='button' data-role='none'>
              <CloseXIcon closeIconTitleId='closeInvalidCombo' closeIconTitleDesc='Close error' />
            </button>
            <p>
              <span>!</span>
              {verbiageToShow}
            </p>
          </div>
        )}
      {props.passedFunctions.parentState.checkForErrors &&
        props.itemKey != undefined &&
        props.itemKey == props.indexClicked &&
        !props.passedFunctions.parentState.formValid &&
        verbiageToShow.length > 0 && (
          <div className='invalidComboContainer' tabIndex='0'>
            <button className='closeTip btn-tertiary' type='button' data-role='none'>
              <CloseXIcon closeIconTitleId='closeInvalidCombo' closeIconTitleDesc='Close error' />
            </button>
            <p>
              <span>!</span>
              {verbiageToShow}
            </p>
          </div>
        )}
    </>
  );
}
